export const saveStep = () => {
    return {
        type: 'CHANGE_STEP_DATA',
        step: 1,
    }
};

export const savePopCount = (value) => {
    return {
        type: 'CHANGE_FIRST_POP_COUNT',
        payload: value,
    }
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Question1/actions.js